import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Kontakt from './pages/Kontakt';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Presse from './pages/Presse';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import Styleguide from './pages/Styleguide';
import Dashboard from './pages/Dashboard';
import Selbstcheck from './pages/Selbstcheck';
import './App.css';

function App() {
  return (
    <Authenticator.Provider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventId" element={<EventDetail />} />
            <Route path="/presse" element={<Presse />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/styleguide" element={<Styleguide />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/szenarien" element={<Navigate to="/" replace />} />
            <Route path="/szenarien." element={<Navigate to="/" replace />} />
            <Route path="/transfer" element={<Navigate to="/" replace />} />
            <Route path="/selbstcheck" element={<Selbstcheck />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Authenticator.Provider>
  );
}

export default App;
